import React from 'react';
import useIntl from 'react-intl/src/components/useIntl';
import { Message } from 'semantic-ui-react';
import { describeValueReset, type FieldDraft } from './fieldDefinitions';

/** Warns that saving will discard stored values. Renders nothing if it won't. */
export function ValueResetWarning({
  existingField,
  draft,
}: {
  existingField: any | null;
  draft: FieldDraft;
}) {
  const { formatMessage } = useIntl();
  const warning = describeValueReset(existingField, draft);

  if (!warning) return null;

  return <Message warning>{formatMessage(warning)}</Message>;
}
